// © Microsoft Corporation. All rights reserved.

import { PageBase } from "@msnews/experiences-redux";

// export default function bootstrapPrimeHybrid(): void {
// Get an instance of the PageBase for this app, and start the app
const app = PageBase.getInstance();

// Start the App
app.start();
